var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelFlagSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2424_2486",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2498 0.544678H3.08317C1.74848 0.544678 0.666504 1.62666 0.666504 2.96134V17.4613C0.666504 18.7961 1.74848 19.878 3.08317 19.878H27.2498C28.5846 19.878 29.6665 18.7961 29.6665 17.4613V2.96134C29.6665 1.62666 28.5846 0.544678 27.2498 0.544678Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2424_2486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6665 0.544678H0.666504V13.4336H29.6665V0.544678Z",
    fill: "#E54252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6665 13.4336H0.666504V19.8781H29.6665V13.4336Z",
    fill: "#5CBE6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80936 16.978V19.878H0.666504V0.544678H4.80936V3.44468L4.11888 4.41134L4.80936 5.37801V7.31135L4.11888 8.27801L4.80936 9.24468V11.178L4.11888 12.1447L4.80936 13.1113V15.0447L4.11888 16.0113L4.80936 16.978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.40479 4.41136L-0.0238268 2.47803L1.35713 4.41136L-0.0238268 6.34469L-1.40479 4.41136ZM-1.40479 8.27805L-0.0238268 6.34469L1.35713 8.27805L-0.0238268 10.2114L-1.40479 8.27805ZM-1.40479 12.1447L-0.0238268 10.2114L1.35713 12.1447L-0.0238268 14.0781L-1.40479 12.1447ZM-1.40479 16.0114L-0.0238268 14.0781L1.35713 16.0114L-0.0238268 17.9447L-1.40479 16.0114Z",
    fill: "#E54252"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.35742 2.47801L2.73837 0.544678L4.11933 2.47801L2.73837 4.41134L1.35742 2.47801ZM1.35742 6.34468L2.73837 4.41134L4.11933 6.34468L2.73837 8.27801L1.35742 6.34468ZM1.35742 10.2113L2.73837 8.27801L4.11933 10.2113L2.73837 12.1447L1.35742 10.2113ZM1.35742 14.078L2.73837 12.1447L4.11933 14.078L2.73837 16.0113L1.35742 14.078ZM1.35742 17.9447L2.73837 16.0113L4.11933 17.9447L2.73837 19.878L1.35742 17.9447Z",
    fill: "#E54252"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelFlagSupport);
export default __webpack_public_path__ + "static/media/bel-flag_support.c83c1a59a8f1408667051bab824b454b.svg";
export { ForwardRef as ReactComponent };